import React from 'react'
import { Box, Flex } from 'rebass/styled-components'
import styled from 'styled-components'
import MediaRender from '../general/MediaRender'
import SwiperRender from './SwiperRender'

const Container = styled(Box)`
    position: relative;
    height: 100%;
    width: 100%;
    .swiper-wrapper {
        margin: 0;
        height: 100%;
        width: 100%;
    }
    .swiper-slide {
        background-color: #000;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }

    .swiper-pagination {
        .swiper-pagination-bullet {
            background-color: ${(props) => props.theme.colors.aquaDark};
            border-right: 1px solid ${(props) => props.theme.colors.white};
            flex-grow: 1;
            height: 6px;
            width: 100%;
            &.swiper-pagination-bullet-active {
                background-color: ${(props) => props.theme.colors.black};
            }
            &:last-child {
                border: none;
            }
        }
    }
`

const SwiperVariable = ({ set, autoplay, slider }) => {
    const slidesArray = []

    if (set && set.length) {
        Object.entries(set).map(([key, image]) => {
            slidesArray.push(
                <MediaRender
                    key={image.filename}
                    file={image}
                    options={{ backgroundImage: true }}
                    alt=''
                    classes='swiper-lazy'
                />
            )
            return true
        })
    }

    let navigationMarkup = null
    let dragSize = null
    let padding = null

    if (slider) {
        dragSize = 5
        padding = '0 0 50px'
        navigationMarkup = (
            <Box>
                <Box
                    className='swiper-scrollbar'
                    height='26px'
                    variant='container'
                    width='100%'
                    sx={{
                        background: 'transparent !important',
                        position: 'relative',
                    }}
                >
                    <Flex
                        alignItems='center'
                        className='swiper-scrollbar-drag'
                        height='100%'
                        width='4px'
                        sx={{
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        <Box
                            bg='aquaDark'
                            height='100%'
                            width='4px'
                        />
                    </Flex>
                    <Box
                        bg='aquaLight'
                        height='4px'
                        width='100%'
                        sx={{
                            position: 'absolute',
                            left: 0,
                            top: 'calc(50% - 2px)',
                        }}
                    ></Box>
                </Box>
            </Box>
        )
    } else {
        dragSize = 60
        padding = '0 0 10px'
        navigationMarkup = (
            <Box
                height='6px'
                width='100%'
                sx={{
                    bottom: 0,
                    left: 0,
                    position: 'absolute',
                    zIndex: 1,
                }}
            >
                <Flex className='swiper-pagination' />
            </Box>
        )
    }

    const invokeSwiper = slidesArray.length > 1 ? true : false
    return (
        <Container>
            <SwiperRender
                options={{
                    style: { width: '100%', height: '100%', padding: padding },
                    allowTouchMove: invokeSwiper,
                    autoHeight: false,
                    autoplay,
                    direction: 'horizontal',
                    followFinger: true,
                    grabCursor: invokeSwiper,
                    longSwipes: true,
                    loop: invokeSwiper,
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination',
                        type: 'bullets',
                        renderBullet: (index, className) => {
                            return '<div class="' + className + '"></div>'
                        },
                    },
                    scrollbar: {
                        draggable: true,
                        dragSize: dragSize,
                        hide: false,
                        snapOnRelease: true,
                    },
                    roundLengths: true,
                    slidesPerView: 1,
                    slides: slidesArray,
                    navigationMarkup,
                }}
            />
        </Container>
    )
}

export default SwiperVariable
